let x;var e;(e=x||(x={})).ID="*xxxxxxxxxxxxxxxxxxxxxx",Object.freeze(e);export{x as MaskType};
